var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareTwitter = function SvgShareTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3D6D8C",
    fillRule: "evenodd",
    d: "M30.5 15c0 8.284-6.716 15-15 15S.5 23.284.5 15s6.716-15 15-15 15 6.716 15 15m-16.698.735-5.88-7.862 4.532.002 3.855 5.154 4.771-5.154h1.33l-5.508 5.948 6.21 8.305h-4.531l-4.186-5.597-5.18 5.597h-1.33zm-1.84-6.88H9.88l9.194 12.293h2.082z",
    clipRule: "evenodd"
  })));
};
export default SvgShareTwitter;